(() => {
  const move = (button, direction) => {
    const carousel = button.closest('[data-km-carousel]');
    const track = carousel?.querySelector('[data-km-carousel-track]');
    if (!track) return;
    const card = track.querySelector('.km-card');
    const gap = parseFloat(getComputedStyle(track).gap || 0);
    const distance = card ? (card.getBoundingClientRect().width + gap) * direction * 2 : track.clientWidth * .85 * direction;
    track.scrollBy({ left: distance, behavior: 'smooth' });
  };
  document.addEventListener('click', (event) => {
    const previous = event.target.closest('[data-km-carousel-prev]');
    const next = event.target.closest('[data-km-carousel-next]');
    if (previous) move(previous, -1);
    if (next) move(next, 1);
  });
})();
